module.exports = __webpack_public_path__ + "static/media/alan-j-anderson-foundation-white.312ef01a.png";